module.exports = __webpack_public_path__ + "NS SR pre BECEP 2021-2030 schválené znenie.pdf";